import { render, staticRenderFns } from "./InfoPubNotice.vue?vue&type=template&id=1b0dbff2&scoped=true"
import script from "./InfoPubNotice.vue?vue&type=script&lang=js"
export * from "./InfoPubNotice.vue?vue&type=script&lang=js"
import style0 from "./InfoPubNotice.vue?vue&type=style&index=0&id=1b0dbff2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0dbff2",
  null
  
)

export default component.exports